import type { RootState } from '@/store/store';

export const API_PREFIX = '/api';

function trimTrailingSlash(value: string): string {
  return value.endsWith('/') ? value.slice(0, -1) : value;
}

export function getApiBaseUrl(): string {
  if (import.meta.env.DEV) {
    return API_PREFIX;
  }

  const configuredBaseUrl = import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_URL || '';
  const normalizedBaseUrl = trimTrailingSlash(configuredBaseUrl);
  return normalizedBaseUrl.endsWith(API_PREFIX)
    ? normalizedBaseUrl
    : `${normalizedBaseUrl}${API_PREFIX}`;
}

export function getStoredAuthToken(): string | null {
  return localStorage.getItem('token');
}

export function clearStoredAuthSession(): void {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
}

export function getAuthTokenFromState(state: unknown): string | null {
  const authState = (state as RootState | undefined)?.auth;
  return authState?.token || getStoredAuthToken();
}

export function createAuthHeaders(token = getStoredAuthToken()): HeadersInit {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function isPublicChatbotUrl(url: string): boolean {
  return url.includes('/chatbot/') && !url.includes('/admin/chatbot');
}

export function handleUnauthorizedResponse(url: string): void {
  if (isPublicChatbotUrl(url)) return;
  clearStoredAuthSession();
  window.location.href = '/login';
}
